// extracted by mini-css-extract-plugin
module.exports = {"previousPrice":"_2a42a3d","selected":"_df4ea3d"};